import { InteractiveTeleportBlock } from './blocks/InteractiveTeleportBlock'
import './InteractiveBlock.css'

export interface InteractiveBlockProps {
	type: 'teleport'
	data: any 
}

export const InteractiveBlock = (props: InteractiveBlockProps) => {
	if (props.type === 'teleport') {
		const data = props.data
		return (
				<InteractiveTeleportBlock 
					size={data.size} 
					image={data.image} 
					buttons={data.buttons}
					title={data.title}
				/>
			)
		}
	
	return (
		<div></div>
	)
}